"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Certificate = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Log_1 = require("@skbkontur/plugin-js/lib/common/Log");

var WideCertificate_1 = require("./WideCertificate");

var NarrowCertificate_1 = require("./NarrowCertificate");

var scroll_into_view_1 = tslib_1.__importDefault(require("scroll-into-view"));

var constants_1 = require("../../utils/constants");

var configuration_1 = require("../../contexts/configuration");

var Certificate =
/** @class */
function (_super) {
  tslib_1.__extends(Certificate, _super);

  function Certificate(props) {
    var _this = _super.call(this, props) || this;

    _this.certRef = null;
    _this.selectedByMouseClick = false;

    _this.onClick = function () {
      _this.selectedByMouseClick = true;
    };

    _this.log = Log_1.LogManager.getLog(constants_1.LOG_PREFIX + "Certificate");
    return _this;
  }

  Certificate.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
    var _this = this;

    if (!this.props.selected && nextProps.selected) {
      window.setTimeout(function () {
        if (!_this.props.selected || _this.selectedByMouseClick) {
          /**
           * Если сертификат выбран мышкой, то не нужно скроллить к нему.
           */
          _this.selectedByMouseClick = false;
          return;
        }

        try {
          scroll_into_view_1.default(_this.certRef.wrapDivRef);
        } catch (error) {
          _this.log.error("Error during scroll to selected component " + error.message);
        }
      }, 200);
    }
  };

  Certificate.prototype.render = function () {
    var _this = this;

    var _a = this.context,
        wide = _a.wide,
        renderCertificate = _a.renderCertificate;
    var Cert = wide ? WideCertificate_1.WideCertificate : NarrowCertificate_1.NarrowCertificate;
    return react_1.default.createElement("div", {
      onClick: this.onClick,
      "data-tid": "certificate_" + this.props.item.certificate.thumbprint()
    }, renderCertificate ? renderCertificate(this.props) : react_1.default.createElement(Cert, tslib_1.__assign({}, this.props, {
      ref: function ref(_ref) {
        return _this.certRef = _ref;
      }
    })));
  };

  Certificate.contextType = configuration_1.configurationContext;
  return Certificate;
}(react_1.default.Component);

exports.Certificate = Certificate;